import { __awaiter, __decorate, __generator, __metadata, __param } from "tslib";
import { AUTH_DATA_INFO, GET_AUTH_CONF, GET_AUTH_EXP, GET_AUTH_INFO, SET_AUTH_EXP, SET_AUTH_INFO, } from './cgi-path';
import { INetworkRequestService } from '../../base/request/network-request.interface';
import { exitOrEmptyString, exitOrZero, getFormDataWithParams } from '../../base/utils';
import { IDocMetaDomainService } from '../../doc-meta/service/doc-meta-domain-service.interface';
import { COMMON_COOKIES_KEYS, getCookieByCommonKey } from '@tencent/ark-utils/lib/cookie';
import { addURLParameters } from '@tencent/ark-utils/lib/url';
var AUTH_INFO_PARAM_TYPE = 1;
var AUTH_INFO_PARAM_VER = 2;
var AuthRepository = /** @class */ (function () {
    function AuthRepository(docMetaDomainService, networkRequestService) {
        this.docMetaDomainService = docMetaDomainService;
        this.networkRequestService = networkRequestService;
    }
    AuthRepository.prototype.fetchAuthInfoData = function (docId) {
        return __awaiter(this, void 0, void 0, function () {
            var params, url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        params = {
                            id: docId,
                            xsrf: "".concat(getCookieByCommonKey(COMMON_COOKIES_KEYS.xsrf)),
                        };
                        url = addURLParameters(AUTH_DATA_INFO, params);
                        return [4 /*yield*/, this.networkRequestService.instance.get(url)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    AuthRepository.prototype.fetchAuthInfo = function () {
        return __awaiter(this, void 0, void 0, function () {
            var params, url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        params = {
                            localPadId: this.docMetaDomainService.docMetaEntity.padInfo.padId,
                            domain: this.docMetaDomainService.docMetaEntity.padInfo.domainId,
                            type: AUTH_INFO_PARAM_TYPE,
                            ver: AUTH_INFO_PARAM_VER,
                            xsrf: "".concat(getCookieByCommonKey(COMMON_COOKIES_KEYS.xsrf)),
                        };
                        url = addURLParameters(GET_AUTH_INFO, params);
                        return [4 /*yield*/, this.networkRequestService.instance.post(url)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    AuthRepository.prototype.changeAuthInfo = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var corpId, data, message, dataType, params, url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        corpId = options.corpId, data = options.data, message = options.message, dataType = options.dataType;
                        params = {
                            localPadId: this.docMetaDomainService.docMetaEntity.padInfo.padId,
                            domain: this.docMetaDomainService.docMetaEntity.padInfo.domainId,
                            corp_id: exitOrEmptyString(corpId),
                            data: exitOrEmptyString(data),
                            message: exitOrEmptyString(message),
                            dataType: exitOrZero(dataType),
                            type: AUTH_INFO_PARAM_TYPE,
                            ver: AUTH_INFO_PARAM_VER,
                            xsrf: "".concat(getCookieByCommonKey(COMMON_COOKIES_KEYS.xsrf)),
                        };
                        url = addURLParameters(SET_AUTH_INFO, params);
                        return [4 /*yield*/, this.networkRequestService.instance.post(url)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    AuthRepository.prototype.fetchAuthExpTime = function () {
        return __awaiter(this, void 0, void 0, function () {
            var params, url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        params = {
                            domainId: this.docMetaDomainService.docMetaEntity.padInfo.domainId,
                            localPadId: this.docMetaDomainService.docMetaEntity.padInfo.padId,
                            xsrf: "".concat(getCookieByCommonKey(COMMON_COOKIES_KEYS.xsrf)),
                            type: AUTH_INFO_PARAM_TYPE,
                            ver: AUTH_INFO_PARAM_VER,
                        };
                        url = addURLParameters(GET_AUTH_EXP, params);
                        return [4 /*yield*/, this.networkRequestService.instance.get(url)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    AuthRepository.prototype.changeAuthExpTime = function (expTime) {
        return __awaiter(this, void 0, void 0, function () {
            var params, config;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        params = getFormDataWithParams({
                            domainId: this.docMetaDomainService.docMetaEntity.padInfo.domainId,
                            localPadId: this.docMetaDomainService.docMetaEntity.padInfo.padId,
                            setTime: parseInt(expTime, 10),
                            xsrf: "".concat(getCookieByCommonKey(COMMON_COOKIES_KEYS.xsrf)),
                        });
                        config = {
                            contentType: 'application/x-www-form-urlencoded',
                        };
                        return [4 /*yield*/, this.networkRequestService.instance.post(SET_AUTH_EXP, params, config)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    AuthRepository.prototype.fetchFolderAuth = function (folderId) {
        return __awaiter(this, void 0, void 0, function () {
            var params, url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        params = {
                            folderId: folderId,
                            type: AUTH_INFO_PARAM_TYPE,
                            ver: AUTH_INFO_PARAM_VER,
                            xsrf: "".concat(getCookieByCommonKey(COMMON_COOKIES_KEYS.xsrf)),
                        };
                        url = addURLParameters(GET_AUTH_INFO, params);
                        return [4 /*yield*/, this.networkRequestService.instance.post(url)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    AuthRepository.prototype.changeFolderAuth = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var folderId, corpId, message, data, clear, params, url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        folderId = options.folderId, corpId = options.corpId, message = options.message, data = options.data, clear = options.clear;
                        params = {
                            folderId: folderId,
                            corp_id: exitOrEmptyString(corpId),
                            data: exitOrEmptyString(data),
                            message: exitOrEmptyString(message),
                            clear: exitOrZero(clear),
                            type: AUTH_INFO_PARAM_TYPE,
                            ver: AUTH_INFO_PARAM_VER,
                            xsrf: "".concat(getCookieByCommonKey(COMMON_COOKIES_KEYS.xsrf)),
                        };
                        url = addURLParameters(SET_AUTH_INFO, params);
                        return [4 /*yield*/, this.networkRequestService.instance.post(url)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * 获取权限相关配置
     */
    AuthRepository.prototype.fetchAuthConfig = function () {
        return __awaiter(this, void 0, void 0, function () {
            var params, url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        params = {
                            domainId: this.docMetaDomainService.docMetaEntity.padInfo.domainId,
                            localPadId: this.docMetaDomainService.docMetaEntity.padInfo.padId,
                            xsrf: "".concat(getCookieByCommonKey(COMMON_COOKIES_KEYS.xsrf)),
                        };
                        url = addURLParameters(GET_AUTH_CONF, params);
                        return [4 /*yield*/, this.networkRequestService.instance.post(url)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    AuthRepository = __decorate([
        __param(0, IDocMetaDomainService),
        __param(1, INetworkRequestService),
        __metadata("design:paramtypes", [Object, Object])
    ], AuthRepository);
    return AuthRepository;
}());
export default AuthRepository;
